<template>
  <section   v-if="variants.v1 === variant" class="counter-section section-padding pt-60 pb-50" :style="`background-color: var(--${vars.backgroundColor})`">
    <div class="row max-md:tw-gap-8">
      <div
        v-for="(count, index) in counts"
        :key="index"
        class="col-md-3 col-12"
      >
        <div class="text-center row">
         <h1 ref="countElements" class="odometer" style="color: var(--c-primary) !important;">
            {{ count.number }}
          </h1>
          <h5>
            {{ count.title }}
          </h5>
        </div>
      </div>
    </div>
  </section >
    <section   v-if="variants.v2 === variant" class="counter-section section-padding pt-60 pb-50" :style="`background-color: var(--${vars.backgroundColor})`">
    <div class="row max-md:tw-gap-8">
      <div
        v-for="(count, index) in counts"
        :key="index"
        class="col-md-3 col-12"
      >
        <div class="text-center row">
         <h1 ref="countElements" class="odometer" style="color: var(--c-primary) !important;">
            {{ count.number }}
          </h1>
          <h5 :style="`color: var(--${vars.textColor});`">
            {{ count.title }}
          </h5>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'CountSection',
  mixins: [ComponentMixin],

   

  data() {
    return {
      observers: [] as IntersectionObserver[],
      animatedElements: new Set(),
       variants: {
        v1: 'v1',
        v2: 'v2',
        
      },
    };
  },

  computed: {
    counts() {
      return this.groupedVariables.counts;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.setupIntersectionObservers();
    });
  },

  beforeUnmount() {
    this.observers.forEach((observer) => observer.disconnect());
  },

  methods: {
    setupIntersectionObservers() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };

      const elements = this.$refs.countElements;
      if (!elements) return;

      (Array.isArray(elements) ? elements : [elements]).forEach((element, index) => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.animatedElements.has(index)) {
              this.updateCount(index);
              this.animatedElements.add(index);
              observer.unobserve(entry.target);
            }
          });
        }, options);

        observer.observe(element);
        this.observers.push(observer);
      });
    },

    updateCount(index: number) {
      const count = this.counts[index];
      const element = this.$el.querySelectorAll('.odometer')[index];
      if (element && count.number) {
        this.animateValue(element, 0, parseInt(count.number, 10), 2000, count.prefix || '', count.suffix || '');
      }
    },

    animateValue(element: HTMLElement, start: number, end: number, duration: number, prefix = '', suffix = '') {
      const frameRate = 60; // Target 60 FPS
      const frameDuration = 1000 / frameRate;
      let currentFrame = 0;
      const totalFrames = Math.round(duration / frameDuration);

      const easeInOutQuad = (t: number) => {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      };

      const animate = () => {
        currentFrame++;
        const progress = currentFrame / totalFrames;
        const easedProgress = easeInOutQuad(progress);
        const currentValue = Math.round(start + (end - start) * easedProgress);

        element.textContent = `${prefix}${currentValue.toLocaleString()}${suffix}`;

        if (currentFrame < totalFrames) {
          setTimeout(animate, frameDuration);
        } else {
          element.textContent = `${prefix}${end.toLocaleString()}${suffix}`; 
        }
      };

      animate();
    },
  },
});
</script>